<template>
  <ion-page>
    <ion-header class="ion-no-border" translucent>
      <ion-toolbar class="-not-fixed">
        <ion-buttons slot="start">
          <back-button
            :defaultHref="{ name: 'home' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text=""
          >
          </back-button>
        </ion-buttons>
        <ion-button
          v-if="$store.state.isLoggedIn"
          @click="$store.commit('setOpenMenu', true)"
          slot="end"
          fill="clear"
          size="large"
          ><ion-icon
            slot="icon-only"
            :src="require('@lib/assets/icons/menu.svg')"
            size="large"
          ></ion-icon
        ></ion-button>
      </ion-toolbar>
    </ion-header>
    <ion-content fullscreen class="ion-padding">
      <ion-grid>
        <h1>Kontakt</h1>
        <div class="c-card -border-grey">
          <h2>Roodie</h2>
          <ion-item lines="none">
            <ion-label position="stacked">Ihre E-Mail Adresse</ion-label>
            <ion-input
              placeholder="adresse@mail.com"
              v-model="formInput['Email']"
            ></ion-input>
          </ion-item>
          <input-error id="Email" />
          <ion-item lines="none" class="ion-margin-top">
            <ion-label position="stacked">Anliegen</ion-label>
            <ion-textarea rows="5" v-model="formInput.Note"></ion-textarea>
          </ion-item>
          <input-error id="Note" />
          <ion-button
            class="ion-margin-top"
            @click="submit"
            :disabled="formInput.Note === ''"
            >Absenden</ion-button
          >
          <!-- <ion-list>
            <ion-item href="mailto:hallo@roodie-health.com" target="_blank">
              <ion-icon
                :icon="mailOutline"
                slot="start"
                size="large"
                color="primary"
              ></ion-icon>
              <ion-label color="primary">Nachricht</ion-label>
            </ion-item>
          </ion-list> -->
        </div>
        <div class="c-card -border-grey">
          <h2>ARAG Kundenservice</h2>
          <ion-list>
            <ion-item
              href="https://www.arag.de/jap/jforms/formulare/standard/00/00/29.faces?p=/kontakt/e-mail"
              target="_blank"
            >
              <ion-icon
                :icon="mailOutline"
                slot="start"
                size="large"
                color="primary"
              ></ion-icon>
              <ion-label color="primary">Nachricht</ion-label>
            </ion-item>
            <ion-item href="tel:+498941248300">
              <ion-icon
                :icon="callOutline"
                slot="start"
                size="large"
                color="primary"
              ></ion-icon>
              <ion-label color="primary">
                <div v-if="showCallNumbers">+49 89 41248300</div>
                <div :class="{ 'u-small': showCallNumbers }">Kundenservice</div>
              </ion-label>
            </ion-item>
          </ion-list>
        </div>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonPage,
  IonHeader,
  IonToolbar,
  // IonTitle,
  IonButtons,
  IonContent,
  IonList,
  // IonListHeader,
  IonItem,
  IonLabel,
  // IonNote,
  IonButton,
  IonIcon,
  //   IonText,
  IonGrid,
  //   IonRow,
  //   IonCol,
  IonTextarea,
  IonInput,
  IonBackButton,
  modalController,
} from "@ionic/vue";
import { chevronBack, mailOutline, callOutline } from "ionicons/icons";
import { apiGetUser } from "@/api/user";
import { contact } from "@/api/contact";
import InputError from "@/components/InputError";
import AlertModal from "@/components/AlertModal";
import { Capacitor } from "@capacitor/core";

export default {
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    // IonTitle,
    IonButtons,
    IonContent,
    IonList,
    // IonListHeader,
    IonItem,
    IonLabel,
    // IonNote,
    IonButton,
    IonIcon,
    // IonText,
    IonGrid,
    // IonRow,
    // IonCol,
    IonTextarea,
    IonInput,
    InputError,
    IonBackButton,
  },
  setup() {
    return { chevronBack, mailOutline, callOutline };
  },
  data() {
    return {
      formInput: {
        Reference: "Roodie Kontaktformular",
        Email: "",
        Note: "",
      },
      showCallNumbers: false,
    };
  },
  mounted() {
    if (Capacitor.getPlatform() === "web") {
      this.showCallNumbers = true;
    }
    apiGetUser().then(() => {
      this.formInput.Email = this.$store.state.user.Email;
    });
  },
  methods: {
    async submit() {
      this.$store.commit("setShowLoading", true);
      const contactResponse = await contact(this.formInput);
      if (contactResponse.data.Status === "Success") {
        this.formInput.Note = "";
        const modal = await modalController.create({
          component: AlertModal,
          cssClass: "c-autoheight-modal",
          componentProps: {
            message: "Wir kümmern uns so rasch wie möglich um Ihr Anliegen.",
            buttons: ["Ok"],
          },
        });
        return modal.present();
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
